import { Directive, HostListener, Input } from '@angular/core';
import { ModalManagementService } from '@wdx/clmi/ui';

@Directive({
    selector: '[modalId]',
    standalone: false,
})
export class ModalDirective {
    @Input() modalId: string;

    @HostListener('click') onClick() {
        this.open();
    }

    constructor(private modalManagementService: ModalManagementService) {}

    open(): void {
        if (this.modalId) {
            this.modalManagementService.openModalWithId(this.modalId);
        }
    }
}
